import PKDHeader from 'components/Home/Header';
import ResearchImage from 'images/research.png';
import { Box } from '@mui/system';
import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { getStyles, StyledLink } from './styles';
import { OutlineButton } from 'shared-components/Buttons/Outline';

const NotEligible = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box>
      <PKDHeader />
      <Box
        sx={styles.mainContainer}>
        <Stack
          sx={styles.stack}>
          <Box>
            <img
              alt='overview'
              src={ResearchImage}
              maxWidth='522px'
              maxHeight='195px'
              style={styles.img}
            />
          </Box>
          <Box
            sx={{ padding: '20px 0px 0px 10px' }}>
            <Box
              sx={styles.title}>Thank you for your interest</Box>
            <Box
              sx={styles.text}>
              At this point of time, you are not eligible to participant in the
              registry. Please access our website, PKD Foundation at{' '}
              <StyledLink
                href='https://pkdcure.org/'>
                https://pkdcure.org/
              </StyledLink>{' '}
              to find other ways you can contribute to PKD research.
            </Box>
            <Box
              sx={styles.btnContainer}>
              <OutlineButton
                width='224px'
                height='40px'
                fontFamily='Montserrat'
                color={theme.palette.primary.blue1}
                borderColor={theme.palette.primary.blue1}
                text='Exit'
                onClickHandler={() => navigate('/')}
              />
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default NotEligible;
